'use client';

import { Box, IconButton, Typography } from '@mui/material';
import { useEffect, useId, useRef, useState } from 'react';

const LABEL = 'Editorial integrity';

export function EditorialIntegrity() {
  const id = useId();
  const dialogRef = useRef<HTMLDialogElement>(null);
  const [supportsCommandFor, setSupportsCommandFor] = useState(true);

  useEffect(() => {
    setSupportsCommandFor(
      'command' in HTMLButtonElement.prototype &&
        'commandForElement' in HTMLButtonElement.prototype,
    );
  }, []);

  return (
    <>
      <Box
        component="button"
        data-testid="byline-editorial-integrity"
        {...(supportsCommandFor
          ? { commandfor: id, command: 'show-modal' }
          : { onClick: () => dialogRef.current?.showModal() })}
        sx={{ display: 'flex', cursor: 'pointer' }}
      >
        <Typography variant="notesHighlightSmall" sx={{ '&:hover': { color: 'white' } }}>
          {LABEL}
        </Typography>
      </Box>
      <Box
        component="dialog"
        id={id}
        ref={dialogRef}
        aria-label={`${LABEL} Modal`}
        onClick={(e: React.MouseEvent<HTMLDialogElement>) => {
          if (e.target === e.currentTarget) e.currentTarget.close();
        }}
        sx={{
          position: 'fixed',
          inset: 'auto 0 0 0',
          width: '100%',
          maxWidth: '100%',
          borderRadius: '8px 8px 0 0',
          boxShadow: '0px -4px 4px 0px #00000026',
          backgroundColor: 'white',
          padding: 0,
          '&::backdrop': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
      >
        <Box
          onClick={e => e.stopPropagation()}
          sx={{
            width: '100%',
            boxSizing: 'border-box',
            paddingTop: '1.5rem',
            paddingBottom: { xs: '2.5rem', sm: '5rem' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '1280px',
              paddingX: 'var(--padding-x)',
              marginX: 'auto',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', sm: 'center' },
                marginBottom: '1.5rem',
              }}
            >
              <Typography variant="textLargeBold">
                NerdWallet is committed to editorial integrity
              </Typography>
              <IconButton
                {...(supportsCommandFor
                  ? { commandfor: id, command: 'close' }
                  : { onClick: () => dialogRef.current?.close() })}
                aria-label={`Close ${LABEL} Modal`}
                sx={{
                  marginLeft: 3,
                  height: '40px',
                  width: '40px',
                }}
              >
                <span
                  aria-hidden="true"
                  className="mask-icon mask-icon-close"
                  style={{ width: '24px', height: '24px' }}
                />
              </IconButton>
            </Box>
            <Typography>
              Many or all of the products on this page are from partners who compensate us when you
              click to or take an action on their website,{' '}
              <strong>
                but this does not influence our evaluations or ratings. Our opinions are our own.
              </strong>
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
